import { POST, postFile, GET } from "../../index";

export const getJurisdiction = (param) => POST("/v1/jurisdiction/getJurisdiction", param);
export const insertJurisdiction = (param) => POST("/v1/jurisdiction/insertJurisdiction", param);
export const updateJurisdiction = (param) => POST("/v1/jurisdiction/updateJurisdiction", param);
export const deleteJurisdiction = (param) => POST("/v1/jurisdiction/deleteJurisdiction", param);
